import script from "./SubMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SubMenu.vue?vue&type=style&index=0&id=bd43fe92&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd43fe92"]])

export default __exports__